const getFilteredCropsByCropSeason = (selectedCs, cs) =>
  selectedCs?.flatMap(cropSeasonId =>
    cs
      ?.find(cropSeason => cropSeason?.id === cropSeasonId)
      ?.crops?.flatMap(crop => [{ key: crop.id, value: crop?.name }])
  );

export default getFilteredCropsByCropSeason;
